import classNames from 'classnames';
import { Button, ButtonProps } from 'react-aria-components/Button';
import { Dialog, DialogTrigger, Heading as DialogHeading } from 'react-aria-components/Dialog';
import { Modal, ModalOverlay } from 'react-aria-components/Modal';

import Icon from '../Icon/Icon';
import Heading, { HeadingSize } from '../Typography/Heading/Heading';
import css from './Drawer.css';

interface DrawerProps {
  children: React.ReactNode;
}

export function Drawer({ children }: DrawerProps) {
  return <DialogTrigger>{children}</DialogTrigger>;
}

type DrawerTriggerProps = Pick<ButtonProps, 'aria-label' | 'children' | 'className'>;

export function DrawerTrigger(props: DrawerTriggerProps) {
  return <Button {...props} />;
}

interface DrawerPanelProps {
  children: React.ReactNode;
  closeButtonLabel: string;
  className?: string;
}

export function DrawerPanel({ children, className, closeButtonLabel }: DrawerPanelProps) {
  return (
    <ModalOverlay className={css.overlay} isDismissable>
      <Modal className={css.modal}>
        <Dialog className={classNames(css.dialog, className)}>
          {children}
          <Button slot="close" className={css.buttonClose} aria-label={closeButtonLabel}>
            <Icon className={css.icon} name="cross" />
          </Button>
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
}

interface DrawerHeaderProps {
  children: React.ReactNode;
}

export function DrawerHeader({ children }: DrawerHeaderProps) {
  return (
    <div className={css.header}>
      <DialogHeading
        slot="title"
        render={(props) => (
          <Heading {...props} level={2} className={classNames(css.heading, props.className)} size={HeadingSize.Small}>
            {children}
          </Heading>
        )}
      />
    </div>
  );
}

interface DrawerContentProps {
  children: React.ReactNode;
  className?: string;
}

export function DrawerContent({ children, className }: DrawerContentProps) {
  return <div className={classNames(css.content, className)}>{children}</div>;
}
